// Adresa odberateľa – rovnaké pravidlá ako backend/services/addressService.js

// Pre HTML atribút pattern (celá hodnota musí vyhovieť)
export const POSTAL_CODE_PATTERN = "\\d{3} ?\\d{2}";
export const STREET_PATTERN = ".*\\d.*";

export const POSTAL_CODE_TITLE = "PSČ musí mať 5 číslic, napr. 831 06.";
export const STREET_TITLE = "Uveďte ulicu aj s číslom domu.";

export const EMPTY_ADDRESS = { street: "", postalCode: "", city: "" };

export function isAddressComplete(user) {
  const street = String(user?.street ?? "").trim();
  const postalCode = String(user?.postalCode ?? "").trim();
  const city = String(user?.city ?? "").trim();
  return /\d/.test(street) && /^\d{3} ?\d{2}$/.test(postalCode) && city !== "";
}

export function formatAddress(user) {
  if (!isAddressComplete(user)) return "";
  return `${user.street}, ${user.postalCode} ${user.city}`;
}
